const INITIAL_STATE = {
  tryRedirect: false,
  showFilters: true
};

const SearchTimeStandardData = {
  INITIAL_STATE,
}

export default SearchTimeStandardData;